export default __webpack_public_path__ + "static/media/baby-14.0535c815.svg";